import { io } from 'socket.io-client'

const socketIO = io(process.env.REACT_APP_BACKEND_URL, { autoConnect: false })

async function connect(data) {
	if(socketIO?.disconnected) {
		socketIO.connect()

		while(!socketIO.connected) {
			await new Promise(r => setTimeout(r, 500))
		}

		console.log('Socket conectado:', socketIO.id)

		socketIO.emit('sync_info', data)
	}
}

function disconnect() {
	if(socketIO?.connected) {
		detachEvents()

		socketIO.disconnect()
	}
}

function sendMessage(identifier, data) {
	socketIO.emit(identifier, data)
}

function addListener(identifier, handler) {
	setTimeout(() => {
		socketIO.on(identifier, handler)
	}, 1000)
}

function removeListener(identifier, handler) {
	socketIO.off(identifier, handler)
}

function detachEvents() {
	if(socketIO?.connected) {
		socketIO.removeAllListeners()
	}
}

export const socket = {
	connect,
	disconnect,
	detachEvents,
	addListener,
	sendMessage,
	removeListener
}